var map = {
	"./accepts_gift_card.png": 61574,
	"./accepts_loyalty_card.png": 78296,
	"./autism_friendly.png": 8134,
	"./billy_chip_logo.png": 3983,
	"./bsl_available.png": 61965,
	"./dementia_friendly.png": 3331,
	"./disabled_accessible.png": 35017,
	"./disabled_accessible_verified.png": 22490,
	"./first_aider_available.png": 73434,
	"./offer_available.png": 92133,
	"./public_toilet.png": 36559,
	"./student_discount_available.png": 58127,
	"./togocup_logo.png": 34428,
	"./welsh_available.png": 25281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16003;